"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = enforceDateValues;
// TODO: this is an ugly hack. axios and other libs probably handle this already, in a better way.
function enforceDateValues(obj) {
    if (!obj)
        return obj;
    for (const [key, value] of Object.entries(obj)) {
        if (typeof value === 'string') {
            var iso = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))(?:Z|(\+|-)([\d|:]*))?$/;
            if (iso.test(value))
                obj[key] = new Date(value);
        }
        else if (typeof value === 'object')
            enforceDateValues(value);
    }
    return obj;
}
//# sourceMappingURL=enforceDate.js.map